import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import DashboardCard from "../components/DashboardCard";
import SignalCard from "../components/SignalCard";
import BlogCard from "../components/BlogCard";
import BrokerCard from "../components/BrokerCard";
import ContactCard from "../components/ContactCard";
import "../styles/HomePage.css";

const HomePage = () => {
  const [isExiting, setIsExiting] = useState(false);
  const navigate = useNavigate();

  const handleExitStart = () => {
    setIsExiting(true);
    setTimeout(() => {
      navigate("/dashboard");
    }, 1000);
  };

  return (
    <div className="flex justify-center items-center h-full">
      <div
        className={`flex flex-col h-full w-full max-w-[1920px] max-h-[1080px] transition-opacity duration-1000 ${
          isExiting ? "opacity-0" : "opacity-100"
        }`}
      >
        {/* Mobile layout */}
        <div className="lg:hidden flex flex-col space-y-4 overflow-auto h-full p-4">
          <div className="h-[300px]">
            <DashboardCard onExitStart={handleExitStart} />
          </div>
          <div className="h-[300px]">
            <SignalCard onExitStart={() => navigate("/signal")} />
          </div>
          <div className="h-[300px]">
            <BlogCard />
          </div>
          <div className="h-[250px]">
            <BrokerCard />
          </div>
          <div className="h-[250px]">
            <ContactCard />
          </div>
        </div>

        {/* Desktop layout - 이미지와 동일한 배치로 수정 */}
        <div className="hidden lg:flex h-full p-4">
          <div className="w-1/2 pr-2">
            <div className="h-1/2 pb-2">
              <DashboardCard onExitStart={handleExitStart} />
            </div>
            <div className="h-1/2 pt-2">
              <SignalCard onExitStart={() => navigate("/signal")} />
            </div>
          </div>
          <div className="w-1/2 pl-2 flex flex-col">
            <div className="h-1/2 pb-2">
              <BlogCard />
            </div>
            <div className="h-1/2 pt-2 flex">
              <div className="w-1/2 pr-2">
                <BrokerCard />
              </div>
              <div className="w-1/2 pl-2">
                <ContactCard />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePage;
